const PriceDescription = ({ description }) => {
  if (!description) return null

  return (
    <span className="mt-2 text-xs font-semibold" style={{ color: '#AD34FE' }}>
      {description}
    </span>
  )
}

export default PriceDescription
